/*
 * @Author: zhujiapeng
 * @Date: 2021-01-26 17:15:11
 * @LastEditors: zhujiapeng
 * @LastEditTime: 2021-02-03 14:39:15
 * @Description: 描述一下咯
 * @@Copyrigh: © 2020 杭州杰竞科技有限公司 版权所有
 */

import React from 'react';
// import { useReducer } from 'react';
import createHistory from 'history/createHashHistory';
import App from '../App';
import FaceSystem from '../modules/face/FaceSystem';
import Login from '../modules/login/Login';
// import { fetchReducer } from "../store/reducers";
import {
  Route,
  Router,
  Switch,
  Redirect
} from 'react-router-dom';

declare var window: any;
const XMHistory: any = createHistory();
window.XMHistory = XMHistory;
export const XMContext: any = React.createContext(null);

export const RootRouter = () => {
  // const [xmState, xmDispatch] = useReducer(fetchReducer, { login: false, count: 0 });
  // return <XMContext.Provider value={{ xmState, dispatch: xmDispatch }}>
  return <Router history={XMHistory}>
    <Switch>
      <Route exact path="/login" render={() => <Login />} />
      <Route path="/" render={() => <App />} />
    </Switch>
  </Router>
  {/* </XMContext.Provider > */ }
}

const routes = [
  {
    path: '/home',
    component: FaceSystem,
    name: '首页'
  }
]

export const MainRouter = () => {
  return (
    <Switch>
      {
        routes.map(({ path, component }, key) => (
          <Route
            key={key}
            path={path}
            render={() => {
              const Component = component;
              return <Component />
            }}
          />
        ))
      }
      <Route exact path='/' render={() => (<Redirect to='/home' />)} />
    </Switch>
  );
}